import React from 'react';

function RawHTML(props) {
    const { block } = props;
    console.log(block)
    return (
        <div className='container' style={{ display: 'flow-root' }}>
        <div className="sun-editor-editable" dangerouslySetInnerHTML={{ __html: block.contentData }} />
        </div>
    );
}

export default RawHTML;